"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidationError = void 0;

var _ramda = require("ramda");

var isValidationError = function isValidationError(err) {
  return (0, _ramda.allPass)([(0, _ramda.pathEq)(['status'], 422), (0, _ramda.pathSatisfies)((0, _ramda.is)(Object), ['data', 'error', 'errors'])])(err);
};

exports.isValidationError = isValidationError;